import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc, query, where, orderBy } from "firebase/firestore";
import { db } from "./config";

// Get all conditions
export const getAllConditions = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "conditions"));
    const conditions = [];
    querySnapshot.forEach((doc) => {
      conditions.push({ id: doc.id, ...doc.data() });
    });
    return conditions;
  } catch (error) {
    console.error("Error getting conditions: ", error);
    return [];
  }
};

// Get only active conditions
export const getActiveConditions = async () => {
  try {
    const q = query(
      collection(db, "conditions"), 
      where("state", "==", "active"),
      orderBy("created_at", "desc")
    );
    const querySnapshot = await getDocs(q);
    const conditions = [];
    querySnapshot.forEach((doc) => {
      conditions.push({ id: doc.id, ...doc.data() });
    });
    return conditions;
  } catch (error) {
    console.error("Error with ordered query, trying without orderBy:", error);
    // If ordering fails, try without orderBy
    try {
      const q = query(
        collection(db, "conditions"), 
        where("state", "==", "active")
      );
      const querySnapshot = await getDocs(q);
      const conditions = [];
      querySnapshot.forEach((doc) => {
        conditions.push({ id: doc.id, ...doc.data() });
      });
      return conditions;
    } catch (secondError) {
      console.error("Error getting active conditions: ", secondError);
      return [];
    }
  }
};

// Add new condition
export const addCondition = async (conditionData) => {
  try {
    const docRef = await addDoc(collection(db, "conditions"), conditionData);
    return docRef.id;
  } catch (error) {
    console.error("Error adding condition: ", error);
    throw error;
  }
};

// Update condition
export const updateCondition = async (id, conditionData) => {
  try {
    const conditionRef = doc(db, "conditions", id);
    await updateDoc(conditionRef, conditionData);
  } catch (error) {
    console.error("Error updating condition: ", error);
    throw error;
  }
};

// Delete condition
export const deleteCondition = async (id) => {
  try {
    const conditionRef = doc(db, "conditions", id);
    await deleteDoc(conditionRef);
  } catch (error) {
    console.error("Error deleting condition: ", error);
    throw error;
  }
}; 